import { render, staticRenderFns } from "./ListSistemaView.vue?vue&type=template&id=3facc6d4&"
import script from "./ListSistemaView.vue?vue&type=script&lang=ts&"
export * from "./ListSistemaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports